import React from 'react'
import styled from 'styled-components'
import { SearchInput, TextArea } from '../Common/CommonStyle'
import { HelveticaNeueBold14, NudistaBold12 } from '../Common/Fonts'
import { Icon, RowFlexDiv, ColumnFlexDiv } from '../Common/CommonStyle'
import Checkbox from 'react-custom-checkbox'

const RadioButton = ({ checkedColor = { checkedColor } }) => {
  const [check, setCheck] = React.useState(false)
  return (
    <RowFlexDiv>
      <Checkbox
        checked={true}
        borderColor='#6B05FC'
        // borderWidth={0}
        icon={
          <div
            style={{
              width: '50%',
              height: '70%',

              marginTop: '15%',
              marginBottom: '15%',
              marginLeft: '15%',
              marginRight: '15%',

              borderRadius: '50%',
              display: 'flex',
              flex: 1,
              backgroundColor: checkedColor,
              alignSelf: 'stretch',
            }}
          ></div>
        }
        borderRadius={20}
        style={{ overflow: 'hidden' }}
        size={15}
      />
    </RowFlexDiv>
  )
}

const RadioDiv = styled.div`
  margin: 0.5rem;
  input[type='radio'] {
    position: absolute;
    opacity: 0;
    + .radio-label {
      &:before {
        content: '';
        background: $color1;
        border-radius: 100%;
        border: 1px solid darken($color1, 25%);
        display: inline-block;
        width: 1.4em;
        height: 1.4em;
        position: relative;
        top: -0.2em;
        margin-right: 1em;
        vertical-align: top;
        cursor: pointer;
        text-align: center;
        transition: all 250ms ease;
      }
    }
    &:checked {
      + .radio-label {
        &:before {
          background-color: $color2;
          box-shadow: inset 0 0 0 4px $color1;
        }
      }
    }
    &:focus {
      + .radio-label {
        &:before {
          outline: none;
          border-color: $color2;
        }
      }
    }
    &:disabled {
      + .radio-label {
        &:before {
          box-shadow: inset 0 0 0 4px $color1;
          border-color: darken($color1, 25%);
          background: darken($color1, 25%);
        }
      }
    }
    + .radio-label {
      &:empty {
        &:before {
          margin-right: 0;
        }
      }
    }
  }
`
const RadioInput = styled.input``
const ContainerLabel = styled.label``

const CheckedSpan = styled.span``

export default RadioButton
